import script from "./SourcesActivityTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SourcesActivityTable.vue?vue&type=script&setup=true&lang=js"

import "./SourcesActivityTable.vue?vue&type=style&index=0&id=5621d5ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5621d5ac"]])

export default __exports__